import { clearComponent, displayEphemeralComponent } from './Ephemeral/Actions.js';
import {SNACKBAR_TEXT} from './HCSnackbar.jsx'

export const ERROR_NAMESPACE = 'error'

export const CONFIRMATION_TEXT = 'CONFIRMATION_TEXT';
export const ERROR_TEXT = 'ERROR_TEXT';
export const CLOSE_ERROR_DIALOG = 'CLOSE_ERROR_DIALOG';

export function showSnackbar(text) {
    return { type: SNACKBAR_TEXT, text: text}
}

export function showErrorDialog(errorText) {
    return displayEphemeralComponent(ERROR_NAMESPACE, errorText)
}

export function closeErrorDialog() {
    return clearComponent(ERROR_NAMESPACE)
}

export function showConfirmDialog(confirmationText, onConfirm, destructive) {
    return {
        type: CONFIRMATION_TEXT,
        confirmationText: confirmationText,
        destructive: destructive,
        confirmAction: () => {
            onConfirm()
        }
    }
}
